import {
    ACTION_SET_ADMIN_INFO,
    ACTION_SET_ADMIN_INFO_ENABLE_INTERVAL,
    type AdminInfoActionTypes,
    type AdminInfoState,
} from '../types/admin-info';

const DEFAULT: AdminInfoState = {
    information: null,
    enableIntervalCheck: false,
};

export function adminInfo(state: AdminInfoState = DEFAULT, action: AdminInfoActionTypes): AdminInfoState {
    switch (action.type) {
        case ACTION_SET_ADMIN_INFO: {
            const adminInfo = { ...state.information, ...action.information };
            return { ...state, information: adminInfo };
        }
        case ACTION_SET_ADMIN_INFO_ENABLE_INTERVAL: {
            const enableCheck = !action.enableIntervalCheck;
            return { ...state, enableIntervalCheck: enableCheck };
        }
        default:
            return state;
    }
}
